/* RosyIron · free gifts by set (replaces Kaching). Rules come from snippets/ri-gifts.liquid.
   PDP: gifts ride in the same /cart/add request (ri-pdp.js asks RIGifts.forVariant).
   Cart: after any cart change, gift lines are brought back in line with the sets in the cart
   (one gift per qualifying set, a rule with `unless` is skipped when that variant is in the cart; gift-only variants: every line is managed; a rule with `tagged` (a product also sold on its own) only manages lines tagged _ri_gift; a gift with no buys is retired and its lines are removed). */
(function(){
  var C=window.RI_GIFTS||{rules:[]}, R=C.rules, G=R.map(function(r){ return r.gift; }).filter(function(g,i,a){ return a.indexOf(g)===i; });
  var TAG={}; R.forEach(function(r){ if(r.tagged) TAG[r.gift]=true; });
  function mine(it){ return !TAG[it.variant_id] || !!(it.properties&&it.properties._ri_gift); }
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function forVariant(v){ v=+v; return R.filter(function(r){ return r.buys.indexOf(v)>-1; }).map(function(r){ return r.gift; }); }
  function plan(items){
    var want={}, have={}, lines={}, upd={}, add=[], own={};
    G.forEach(function(g){ want[g]=0; have[g]=0; lines[g]=[]; });
    var ids=items.map(function(it){ return it.variant_id; });
    var on=R.filter(function(r){ return !(r.unless||[]).some(function(u){ return ids.indexOf(u)>-1; }); });
    items.forEach(function(it){
      if(!mine(it)){ own[it.variant_id]=(own[it.variant_id]||0)+it.quantity; return; }
      on.forEach(function(r){ if(r.buys.indexOf(it.variant_id)>-1) want[r.gift]+=it.quantity; });
      if(G.indexOf(it.variant_id)>-1&&mine(it)){ have[it.variant_id]+=it.quantity; lines[it.variant_id].push(it); }
    });
    G.forEach(function(g){
      var d=Math.max(0,want[g]-(own[g]||0))-have[g], ls=lines[g]; if(!d) return; /* a glove the customer bought already counts as the Kit glove (BXGY frees the cheapest items) */
      if(d>0){ if(ls.length) upd[ls[0].key]=ls[0].quantity+d; else add.push({ id:g, quantity:d, properties:{ _ri_gift:'1' } }); return; }
      d=-d; for(var i=ls.length-1;i>=0&&d>0;i--){ var n=Math.min(d,ls[i].quantity); upd[ls[i].key]=ls[i].quantity-n; d-=n; }
    });
    return { upd:upd, add:add };
  }
  function post(u,b){ return fetch(root+u,{ method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify(b) }).then(function(r){ return r.json(); }); }
  function bubble(){
    return fetch(root+'?sections=cart-icon-bubble').then(function(r){ return r.json(); }).then(function(s){
      var el=document.getElementById('cart-icon-bubble'); if(!el||!s['cart-icon-bubble']) return;
      var n=new DOMParser().parseFromString(s['cart-icon-bubble'],'text/html').querySelector('.shopify-section'); if(n) el.innerHTML=n.innerHTML;
    }).catch(function(){});
  }
  function refresh(){
    if(/\/cart\/?$/.test(location.pathname)){ location.reload(); return; }
    var d=document.querySelector('cart-drawer');
    if(d&&d.classList.contains('active')&&d.refreshCartDrawer){ d.refreshCartDrawer(); return; }
    if(window.publish&&window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate,{ source:'ri-gifts' });
    bubble();
  }
  var busy=false, again=false;
  function sync(force){
    if(busy){ again=true; return Promise.resolve(); } busy=true;
    return fetch(root+'cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var p=plan(cart.items), s=Promise.resolve(), ch=!!force;
      if(Object.keys(p.upd).length){ ch=true; s=s.then(function(){ return post('cart/update.js',{ updates:p.upd }); }); }
      if(p.add.length){ ch=true; s=s.then(function(){ return post('cart/add.js',{ items:p.add }); }); }
      return s.then(function(){ if(ch) refresh(); });
    }).catch(function(e){ console.error('ri-gifts',e); }).then(function(){ busy=false; if(again){ again=false; sync(); } });
  }
  /* cart drawer "Upgrade to the Complete Kit": swap the line to the Kit, same quantity, then gifts follow */
  function upgrade(btn){
    if(btn.classList.contains('is-loading')) return; btn.classList.add('is-loading');
    post('cart/change.js',{ id:btn.dataset.key, quantity:0 })
      .then(function(){ return post('cart/add.js',{ items:[{ id:+btn.dataset.to, quantity:+btn.dataset.qty }] }); })
      .then(function(){ return sync(true); })
      .catch(function(e){ console.error('ri-gifts upgrade',e); btn.classList.remove('is-loading'); });
  }
  window.RIGifts={ forVariant:forVariant, sync:sync, upgrade:upgrade };
  function init(){
    if(window.subscribe&&window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate,function(e){ if(e&&e.source==='ri-gifts') return; setTimeout(sync,0); });
    if(C.fix) sync();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
